export const NEXT_AUTH_METHOD = process.env.NEXT_AUTH_METHOD || 'email';

export const CERTIFICATE_STATUS = {
  ACTIVE: 'Đang hoạt động',
  INACTIVE: 'Chưa kích hoạt',
  DEACTIVATE: 'Hết hiệu lực',
} as const;
